import { Menu } from '@mui/material';
import React from 'react';
import { DropdownAnchor, DropdownItem, useDropdownControls } from './Dropdown';
import { Avatar, AvatarProps } from '../avatar';
import { IconButton, IconButtonProps } from '../iconButton';

interface UserActionBase {
  label: string;
}

interface UserActionClick extends UserActionBase {
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  href?: string;
}

interface UserActionHref extends UserActionBase {
  href: string;
  onClick?: UserActionClick['onClick'];
}

interface UserAvatarProps extends Omit<IconButtonProps, 'size' | 'children' | 'aria-label' | 'color' | 'variant' > {
  userInitials: string;
  color?: AvatarProps['color'];
}

type UserAction = UserActionClick | UserActionHref;

export const UserAvatar = ({
  userInitials,
  color,
  ...props
}: UserAvatarProps) => (
  <IconButton
    size="large"
    aria-label={userInitials}
    {...props}
  >
    <Avatar size="sm" color={color}>
      {userInitials}
    </Avatar>
  </IconButton>
);

export interface UserMenuProps extends UserAvatarProps {
  userInitials: string;
  actions: UserAction[];
}

function UserMenu({
  actions, ...props
}: UserMenuProps) {
  const [anchorEl, handleOpen, handleClose] = useDropdownControls(
    props.onClick,
  );

  return (
    <>
      <UserAvatar
        {...props}
        onClick={handleOpen}
        selected={Boolean(anchorEl)}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {actions.map((action) => (
          <DropdownItem key={action.label}>
            <DropdownAnchor href={action.href} onClick={action.onClick}>
              {action.label}
            </DropdownAnchor>
          </DropdownItem>
        ))}
      </Menu>
    </>
  );
}

export default React.memo(UserMenu);
